import layout from 'layouts/default'
import toastr from 'toastr'
import formFields from './formFields'

export default {
  name: 'edit-integration-system',
  components: {
    layout,
    formFields
  },
  data () {
    return {
      form: {
        name: '',
        type: 'parking',
        attributes: []
      },
      loading: true,
      processing: false,
      errors: {}
    }
  },
  methods: {
    submit () {
      this.errors = {}
      this.processing = true

      this.$store.dispatch('integrationSystems.update', {
        id: this.$route.params.id,
        data: this.form
      }).then(() => {
        this.processing = false
        const error = this.$store.state.integrationSystems.errors
        if (error) {
          this.errors = _.cloneDeep(error.errors || {})
          toastr.error(error.message)
        } else {
          this.form = this.normalizedForm(this.$store.state.integrationSystems.active)
          toastr.success('Data has been saved')
        }
      })
    },

    normalizedForm (system) {
      return Object.assign({
        name: '',
        type: 'parking',
        attributes: []
      }, _.cloneDeep(system), {
        attributes: _.cloneDeep(system.attributes || [])
      })
    }
  },
  mounted () {
    this.$store.dispatch('integrationSystems.get', this.$route.params.id).then(() => {
      this.loading = false
      const error = this.$store.state.integrationSystems.errors
      if (error) {
        toastr.error(error.message)
        return
      }
      this.form = this.normalizedForm(this.$store.state.integrationSystems.active)
    })
  }
}
